import { createFileRoute } from "@tanstack/react-router";
import UuidGeneratorPage from "@/pages/UuidGeneratorPage";

export const Route = createFileRoute("/tools/uuid-generator")({
  component: UuidGeneratorPage,
});
